import { render, staticRenderFns } from "./CreatePerformanceReportTablePage.vue?vue&type=template&id=b3fb4f5e&scoped=true"
import script from "./CreatePerformanceReportTablePage.vue?vue&type=script&lang=js"
export * from "./CreatePerformanceReportTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb4f5e",
  null
  
)

export default component.exports